// extracted by mini-css-extract-plugin
module.exports = {"video-container":"video-container-v9_vA","video":"video-tkpQm"};